
// import React, { useState } from 'react';
// import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
// import { Link } from 'react-router-dom';
// import {

//   Home, Settings, Users, BarChart, Calendar, NotebookPen, Bed,
//   Receipt, Truck, FileText
// } from 'lucide-react';
// import AppointmentList from './../../Receptionist/AppointmentList';

// const AppSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false);
//     const [activeTab, setActiveTab] = useState(''); 

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed);
//   };

//     const getStyle = (tabName) => ({
//     backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
//     borderRadius: activeTab === tabName ? '50px' : '0px',
//     color: activeTab === tabName ? '#fff' : 'inherit',
//     margin: activeTab === tabName ? '5px' : '0px',
//   });


//   return (
//     <div style={{ display: 'flex', height: '100%'  }} className='shadow '>
//       <Sidebar collapsed={collapsed}>
//        <Menu>
//   <MenuItem onClick={toggleSidebar}> {collapsed ? '' : ''} ☰ </MenuItem>



//   <MenuItem
//    component={<Link to="/doctor/home" />}  
//   style={getStyle('doctor_dashboard')}
//             onClick={() => setActiveTab('doctor_dashboard')}
//             >
//               Doctor Dashboard
//             </MenuItem>
//   <MenuItem component={<Link to="/doctor/home/appointments-list" />} icon={<FileText size={16} />}   style={getStyle('appointment_list')}
//             onClick={() => setActiveTab('appointment_list')}>
//     Appointment List
//   </MenuItem>
//    <MenuItem component={<Link to="/doctor/home/patients-list" />} icon={<NotebookPen size={16} />}    style={getStyle('patients_list')}
//             onClick={() => setActiveTab('patients_list')}>Patients List</MenuItem>

//   <SubMenu label="Schedule" icon={<Calendar size={16} />}    style={getStyle('schedule')}
//             onClick={() => setActiveTab('schedule')}>
//     <MenuItem component={<Link to="/doctor/home/check-slots" />} style={getStyle('appointment_calendar')}
//             onClick={() => setActiveTab('appointment_calendar')}>Appointment Calendar</MenuItem>
//     {/* <MenuItem component={<Link to="/doctor/home/calendar" />}>Calendar</MenuItem> */}
//     <MenuItem component={<Link to="/doctor/home/bookings" />}   style={getStyle('schedule_timing')}
//             onClick={() => setActiveTab('schedule_timing')}> Schedule Timing</MenuItem>
//   </SubMenu>

//  <MenuItem component={<Link to="/doctor/home/invoice-list" />} icon={<FileText size={16} />} style={getStyle('invoice_list')}
//             onClick={() => setActiveTab('invoice_list')}>
//     Invoice List
//   </MenuItem>

// //   {/* <MenuItem component={<Link to="/doctor/home/prescriptions" />} icon={<NotebookPen size={16} />}>
// //     Prescriptions
// //   </MenuItem> */}

//   <MenuItem component={<Link to="/doctor/home/pharmacy" />} icon={<FileText size={16} />} style={getStyle('pharmacy')}
//             onClick={() => setActiveTab('pharmacy')}>
//     Pharmacy
//   </MenuItem>
//    <MenuItem component={<Link to="/doctor/home/inventory" />} icon={<FileText size={16} />}  style={getStyle('inventory')}
//             onClick={() => setActiveTab('inventory')}>
//     Inventory
//   </MenuItem>
// </Menu>

//       </Sidebar>
//     </div>
//   );
//  };

//  export default AppSidebar;

import React, { useState } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import 'boxicons/css/boxicons.min.css';


const AppSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);


  const location = useLocation();

  const isActive = (path) => location.pathname === path;


  const [activeTab, setActiveTab] = useState('');

  // const toggleSidebar = () => {
  //   setCollapsed(!collapsed);
  // };

  const getStyle = (tabName) => ({
    backgroundColor: activeTab === tabName ? '#21766f' : 'transparent',
    borderRadius: activeTab === tabName ? '50px' : '0px',
    color: activeTab === tabName ? '#fff' : 'inherit',
    margin: activeTab === tabName ? '5px' : '0px',
     paddingTop: activeTab === tabName ? '7px' : '0px',
          
     paddingBottom: activeTab === tabName? '7px' : '0px',
  });

  return (
    <div style={{ display: 'flex', height: '100vh',position:"relative" }}>

      <Sidebar collapsed={collapsed} backgroundColor="#f9f9f9">
        <Menu>
          <MenuItem onClick={() => setCollapsed(!collapsed)} icon={<i className="bx bx-menu" />}></MenuItem>

          <MenuItem
            icon={<i className="bx bxs-dashboard sidebar-icon" />}
            component={<Link to="/doctor/home" />}
            className={`sidebar-item ${isActive("/doctor/home") ? 'active' : ''}`}
            style={getStyle('doctor_dashboard')}
            onClick={() => setActiveTab('doctor_dashboard')}
          >
            Doctor Dashboard
          </MenuItem>

          <MenuItem
            icon={<i className="bx bxs-file sidebar-icon" />}
            component={<Link to="/doctor/home/appointments-list" />}
            className={`sidebar-item ${isActive("/doctor/home/appointments-list") ? 'active' : ''}`}
            style={getStyle('appointment_list')}
            onClick={() => setActiveTab('appointment_list')}
          >
            Appointment List
          </MenuItem>

          <MenuItem
            icon={<i className="bx bxs-notepad sidebar-icon" />}
            component={<Link to="/doctor/home/patients-list" />}
            className={`sidebar-item ${isActive("/doctor/home/patients-list") ? 'active' : ''}`}
            style={getStyle('patients_list')}
            onClick={() => setActiveTab('patients_list')}
          >
            Patients List
          </MenuItem>

          <SubMenu
            label="Schedule"
            icon={<i className="bx bxs-calendar sidebar-icon" />}
            className="sidebar-item"
            style={getStyle('schedule')}
            onClick={() => setActiveTab('schedule')}

          >
            <MenuItem component={<Link to="/doctor/home/check-slots" />} style={getStyle('apppointment_calendar')}
              onClick={() => setActiveTab('apppointment_calendar')}>Appointment Calendar</MenuItem>
            <MenuItem component={<Link to="/doctor/home/bookings" />} style={getStyle('schedule_timing')}
              onClick={() => setActiveTab('schedule_timing')}>Schedule Timing</MenuItem>
          </SubMenu>

          <MenuItem
            icon={<i className="bx bxs-file sidebar-icon" />}
            component={<Link to="/doctor/home/invoice-list" />}
            className={`sidebar-item ${isActive("/doctor/home/invoice-list") ? 'active' : ''}`}
            style={getStyle('invoice_list')}
            onClick={() => setActiveTab('invoice_list')}
          >
            Invoice List
          </MenuItem>

          <MenuItem
            icon={<i className="bx bxs-capsule sidebar-icon" />}
            component={<Link to="/doctor/home/pharmacy" />}
            className={`sidebar-item ${isActive("/doctor/home/pharmacy") ? 'active' : ''}`}
            style={getStyle('pharmacy')}
            onClick={() => setActiveTab('pharmacy')}
          >
            Pharmacy
          </MenuItem>

          <MenuItem
            icon={<i className="bx bxs-box sidebar-icon" />}
            component={<Link to="/doctor/home/inventory" />}
            className={`sidebar-item ${isActive("/doctor/home/inventory") ? 'active' : ''}`}
            style={getStyle('inventory')}
            onClick={() => setActiveTab('inventory')}
          >
            Inventory
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default AppSidebar;





